<div class="banner" role="banner">
  <h1>{{ 'predictor.banner.text' | translate }}</h1>
</div>

<div class="predictor-v2-page">
  <fgb-leaderboard-v2-nav routeLink="predictor"></fgb-leaderboard-v2-nav>
  <router-outlet></router-outlet>
</div>
